import React, { useState } from "react";
import { Select } from "antd";
import PropTypes from "prop-types";
import { listEmployees } from "../../../api/server";
import { useIntl } from "react-intl";
import { getFullName } from "../../../components/util/helpers";
const { Option } = Select;

const EmployeeSelect = (props) => {
  const { onChange, branch, initialName, error, popupContainer, ...rest } =
    props;
  const [data, setData] = useState([]);
  const intl = useIntl();

  const onFocus = () => {
    if (data.length === 0) {
      listEmployees({
        current: 1,
        pageSize: 100,
        filter: {
          $and: [
            {
              $or: [
                { professional_role_id: 1 },
                { professional_role_id: 2 },
                { professional_role_id: 3 },
                { professional_role_id: 4 },
                { controller: true },
              ],
            },
            { $or: [{ status: 1 }, { status: 3 }] },
          ],
        },
        scopePrefix: branch && `branches/${branch}/`,
      }).then(({ error, data }) => {
        if (data) {
          setData(data.items);
        }
      });
    }
  };

  const getOptionLabel = (option) => {
    let name = getFullName(option.surename, option.first_name);
    if (option.professional_role_id) {
      const role = intl.formatMessage({
        id: `app.dataSelect.professional_role_id.${option.professional_role_id}`,
      });
      name = name.concat(", ", role);
    }
    return name;
  };

  return (
    <Select
      {...rest}
      onChange={onChange}
      showSearch={true}
      filterOption={(input, option) => option.children.indexOf(input) >= 0}
      getPopupContainer={(trigger) =>
        popupContainer ? popupContainer : undefined
      }
      style={{
        width: "100%",
        border: error ? "1px solid red" : "initial",
        borderRadius: error ? "5px" : "initial",
      }}
      defaultValue={initialName}
      onFocus={onFocus}
    >
      {data.map((option) => (
        <Option key={option["id"]} value={option["id"]}>
          {getOptionLabel(option)}
        </Option>
      ))}
    </Select>
  );
};

EmployeeSelect.propTypes = {
  onChange: PropTypes.func,
};

export default EmployeeSelect;
